module.exports = __webpack_public_path__ + "static/media/ditributeur.f4844d1f.gif";